import React, { useState, useEffect } from "react";
import { object, func, string } from "prop-types";
import { connect } from "react-redux";
import { get } from "lodash";

import Headline from "../../atoms/Headline";
import SearchInput from "../../atoms/SearchInput";
import SearchStories1AdWithLoadMore from "../../rows/SearchStories1AdWithLoadMore";

import { setLoading } from "../../helper/actions";
import { getSearchStories } from "../../helper/api";
import { staticTexts } from "../../utils/Translate";
import { useAutoRefresh } from "../../utils/react-utils";

import "./search.m.css";

const FIRST_TIME_NO_OF_STORIES_TO_LOAD = 10;
const NO_OF_STORIES_TO_LOAD = 6;

function SearchPageView({ data, setLoading, publisherAttributes, pageType }) {
  const [stories, setStories] = useState(data.stories);
  const [offset, setOffset] = useState(data.stories.length);
  const [total, setTotal] = useState(data.total);
  const [isMoreStories, setIsMoreStories] = useState(data.stories.length < data.total);
  const [params, setParams] = useState({ q: data.query });
  const [showButtonSpinner, setButtonSpinner] = useState(false);

  // Load More stories
  const getLoadMoreStories = () => {
    setButtonSpinner(true);

    getSearchStories(offset, NO_OF_STORIES_TO_LOAD, params)
      .then((result) => {
        const updatedResults = [].concat(stories, result.items);

        setTotal(result.total);
        setOffset(updatedResults.length); // Keep next offset ready
        setStories(updatedResults);
        setIsMoreStories(updatedResults.length < result.total);
      })
      .finally(() => setButtonSpinner(false));
  };

  // Load the Stories for first time being called from other compoenents
  const getStories = (paramsObj) => {
    setLoading(true);

    paramsObj.q = data.query;
    setParams(paramsObj);

    getSearchStories(0, FIRST_TIME_NO_OF_STORIES_TO_LOAD, paramsObj)
      .then((result) => {
        setTotal(result.total);
        setOffset(result.items.length); // Keep next offset ready
        setStories(result.items);
        setIsMoreStories(result.items.length < result.total);
      })
      .finally(() => setLoading(false));
  };

  const onLoadMore = () => getLoadMoreStories();

  useEffect(() => {
    const inputElements = document.getElementsByTagName("input");
    Array.from(inputElements).forEach((item) => item.blur());
  }, [pageType]);

  useAutoRefresh(pageType);

  return (
    <React.Fragment>
      <div>
        <div styleName="content">
          <div styleName="title-details">
            <Headline
              text={staticTexts(publisherAttributes.lang).advanceSearch}
              headerLevel={1}
              headlineType={27}
              className={`title ${publisherAttributes.lang === "en" ? "en-title" : ""}`}
            />
            <SearchInput defaultValue={data.query} lang={publisherAttributes.lang} />
          </div>
        </div>

        <SearchStories1AdWithLoadMore
          total={total}
          list={stories}
          onLoadMore={onLoadMore}
          isMoreStories={isMoreStories}
          getStories={getStories}
          showButtonSpinner={showButtonSpinner}
        />
      </div>
    </React.Fragment>
  );
}

SearchPageView.propTypes = {
  data: object,
  setLoading: func,
  setAuthors: func,
  publisherAttributes: object,
  pageType: string,
};

const mapStateToProps = (state) => ({
  publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {}),
  pageType: get(state, ["qt", "pageType"], ""),
});

const mapDispatchToProps = (dispatch) => ({
  setLoading: (isLoading) => dispatch(setLoading(isLoading)),
});

const SearchPage = connect(mapStateToProps, mapDispatchToProps)(SearchPageView);

export { SearchPage };
